// extracted by mini-css-extract-plugin
module.exports = {"header":"BlogHeader-module--header--y-0Qe","blogHeader":"BlogHeader-module--blogHeader--P8AqC","blogHeader__content":"BlogHeader-module--blogHeader__content--3cBSv"};